// Introducing the method of registering components
import { withInstall } from '@/utils';
// Introducing Components
import tags from './AsinTag.vue';
// Throw component  asinTag
export const AsinTag = withInstall(tags, 'AsinTag');
